import React, { useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { useIsMount } from '../../../hooks/useIsMountHook';
import _ from 'lodash';
import { decodeBase64, encodeBase64 } from '../../../utils/stringUtils';
import SmartTextArea from '../../textarea/SmartTextArea';

interface RequestBodyProps {
  requestBody: string;
  onChange: (value: string) => void;
}

const RequestBody = ({ requestBody, onChange }: RequestBodyProps) => {
  const [body, setBody] = React.useState<string>(decodeBase64(requestBody));

  const isMount = useIsMount();
  useEffect(() => {
    const debounceOnChange = _.debounce((value: string) => onChange(encodeBase64(value)), 600);
    if (!isMount && body !== decodeBase64(requestBody)) {
      debounceOnChange(body);
    }
    return () => debounceOnChange.cancel();
  }, [body]);

  useEffect(() => {
    const decodedRequestBody = decodeBase64(requestBody);
    if (!isMount && body !== decodedRequestBody) {
      setBody(decodedRequestBody);
    }
  }, [requestBody]);

  return (
    <SmartTextArea
      label={'Request Body'}
      text={body}
      onChange={value => {
        setBody(value);
      }}
    />
  );
};

export default RequestBody;
